
import { User } from './user';
import {CurrentProfile} from './currentprofile';
import { UserDetails } from './user.details';

export const dataModelContainer = [
    User,
    CurrentProfile,
    UserDetails
];

export { User } from './user';
export { CurrentProfile } from './currentprofile';
export { UserDetails } from './user.details';

